import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTaxi, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import NavigationButtons from './NavigationButtons';
import './NavigationButtons.css';
import './RouteDetails.css';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

function openDeeplink(deeplinkUrl, fallbackUrl) {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    window.location.href = deeplinkUrl;
    // Optionally, set a timeout to redirect to fallbackUrl if app is not installed
    // setTimeout(() => {
    //   window.location.href = fallbackUrl;
    // }, 2000);
  } else {
    window.open(deeplinkUrl, '_blank');
  }
}

const RouteDetailsTaxi = ({ 
  from, 
  to, 
  selectedRoute, 
  setShowTaxiOverlay, 
  setSelectedRoute 
}) => {
  const AIRASIA_RIDES_URL = process.env.REACT_APP_AIRASIA_RIDES_URL || "https://airasia.com/ride/rebook";
  return (
    <div className="route-details-overlay">
      <div className="route-details-header">
        <div className="route-details-title">
          <FontAwesomeIcon icon={faTaxi} style={{ color: '#FFD700' }} /> {from} to {to}
        </div>
        <button onClick={() => setShowTaxiOverlay(false)} className="route-details-close-button">
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
      </div>

      {selectedRoute && (
        <div className="route-details-summary-card">
          <div className="route-details-journey-title">
            Journey overview
          </div>

          <div className="route-details-duration-distance">
            ⏱ <strong>{selectedRoute.duration}</strong> &nbsp; • &nbsp; 📏 {selectedRoute.distance}
          </div>

          <div className="route-details-price">
            🧾 Price estimate: <strong>{selectedRoute.fare}</strong>
          </div>

          <div className="route-details-note">
            Doesn't include surcharges, tolls or delays. Always check with the operator.
          </div>
          {/* <div className="airasia-book-btn-wrapper">
            <button
              className="airasia-book-btn"
              onClick={() => {
                const from_lat = selectedRoute.routeDetails[0].startLocation?.latitude;
                const from_lng = selectedRoute.routeDetails[0].startLocation?.longitude;
                const destination_lat = selectedRoute.routeDetails[selectedRoute.routeDetails.length-1].endLocation?.latitude;
                const destination_lng = selectedRoute.routeDetails[selectedRoute.routeDetails.length-1].endLocation?.longitude;
                const url = `${AIRASIA_RIDES_URL}?from_lat=${from_lat}&from_lng=${from_lng}&destination_lat=${destination_lat}&destination_lng=${destination_lng}`;
                const webUrl = `https://airasia.com/ride/rebook?from_lat=${from_lat}&from_lng=${from_lng}&destination_lat=${destination_lat}&destination_lng=${destination_lng}`;
                openDeeplink(url, webUrl);
              }}
            >
              <i className="fa fa-taxi" style={{fontSize: '18px'}}></i>
              Book with AirAsia Rides
            </button>
          </div> */}
        </div>
      )}

      
      <NavigationButtons
        from={from}
        to={to}
        setSelectedRoute={setSelectedRoute}
        selectedRoute={selectedRoute}
        travelMode="driving"
      />
    </div>
  );
};

export default RouteDetailsTaxi; 
